import { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const LogoutPage = () => {
  const { logout, userManagementEnabled } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userManagementEnabled) {
      return;
    }

    void logout();
    const timeoutId = window.setTimeout(() => {
      navigate("/login", { replace: true });
    }, 2000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [logout, navigate, userManagementEnabled]);

  if (!userManagementEnabled) {
    return <Navigate to="/player" replace />;
  }

  return (
    <Box textAlign="center" mt={4}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Signing you out...
      </Typography>
    </Box>
  );
};

export default LogoutPage;
